import { Box, Divider, Grid, Typography } from '@mui/material'
import { DataPanel } from '../../../components/DataPanel'
import MultistepFormField from '../../../components/MultistepForm/MultistepFormField'

const BillingDentistStep = () => {
    return (
        <Box>
            <DataPanel
                title="Billing Dentist or Dental Entity"
                content={
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography>
                                Leave blank if dentist or dental entity is not submitting claim on
                                behalf of the patient or insured / subscriber
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <MultistepFormField label="Name" name="billingDentist-name" />
                        </Grid>
                        <Grid item xs={4}>
                            <MultistepFormField label="City" name="billingDentist-city" />
                        </Grid>
                        <Grid item xs={4}>
                            <MultistepFormField label="Zip Code" name="billingDentist-zipCode" />
                        </Grid>
                        <Grid item xs={4}>
                            <MultistepFormField label="Address" name="billingDentist-address" />
                        </Grid>
                        <Grid item xs={4}>
                            <MultistepFormField label="State" name="billingDentist-state" />
                        </Grid>
                        <Grid item xs={4} />
                        <Grid item xs={12}>
                            <Divider />
                        </Grid>
                        <Grid item xs={4}>
                            <MultistepFormField
                                label="Provider ID"
                                name="billingDentist-providerId"
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <MultistepFormField
                                label="License Number"
                                name="billingDentist-licenseNumber"
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <MultistepFormField label="SSN or TIN" name="billingDentist-ssn" />
                        </Grid>
                        <Grid item xs={4}>
                            <MultistepFormField
                                label="Phone Number"
                                name="billingDentist-phoneNumber"
                                type="phone"
                                inputProps={{ sx: { width: '100%' } }}
                            />
                        </Grid>
                    </Grid>
                }
            />
        </Box>
    )
}

export default BillingDentistStep
